import React from "react";
import dynamic from "next/dynamic";
import Seo from "src/components/shared/Seo";
import server from "src/api/server";
import { useRouter } from "next/router";
const ServicesComponent = dynamic(() => import("src/modules/services/Index"));

const ServicesPage = ({
  data,
  appSetting = {},
  metaData = [],
  footerSettings,
}) => {
  const router = useRouter();
  const { locale } = router;

  const customMeta = [
    { name: "title", content: metaData?.[0]?.name?.[locale] },
    {
      name: "description",
      content: metaData?.[0]?.content?.[locale],
    },
  ];

  return (
    <>
      <Seo
        metaData={customMeta}
        appSetting={{
          ...appSetting,
          ...footerSettings,
        }}
        pageUrl={
          typeof window !== "undefined"
            ? window.location.href
            : `${process.env.NEXT_PUBLIC_SITE_URL}/${router.asPath}`
        }
      />
      <ServicesComponent data={data} />
    </>
  );
};

export async function getStaticProps() {
  const [
    servicesRes,
    questionsRes,
    indexRes,
    metaRes,
    footerRes,
  ] = await Promise.all([
    server.get("/api/services"),
    server.get("/api/posts/questions_services/all"),
    server.get("/api/index"),
    server.get("/api/metadataTags?type=services"),
    server.get("/api/footer"),
  ]);

  return {
    props: {
      data: {
        servicesData: servicesRes?.data?.data || null,
        questions: questionsRes?.data?.data || null,
      },
      metaData: metaRes?.data?.data?.metadata_tags || null,
      appSetting: indexRes?.data?.data?.AppSetting || null,
      footerSettings: footerRes?.data?.data || null,
    },
    revalidate: 10,
  };
}

export default ServicesPage;
